<template>
  <button @click="toogle"
          @keydown.enter.prevent="toogle"
          @keydown.space.prevent="toogle"
          tabindex="0"
          role="button"
          :aria-pressed="active ? 'true' : 'false'"
          :aria-label="ariaLabel"
          class="item"
          :class="{ active: active }"
          :style="{ zIndex: !active ? row : 10-row }">
    <span class="kernel" aria-hidden="true">
      <span class="kernel-ring"></span>
      <span class="kernel-body"></span>
      <span class="kernel-sheen"></span>
    </span>
  </button>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'item',
  props: ['row', 'col', 'bar'],
  computed: {
    ...mapState({
      active (state) {
        let active = state.abacus[this.bar][this.row - 1][this.col - 1]
        return (this.bar !== 'bottom' && active) || (this.bar === 'bottom' && !active)
      }
    }),
    ariaLabel () {
      let section = this.bar === 'top' ? 'top section' : 'bottom section'
      let state = this.active ? 'active' : 'inactive'
      return 'Bead at column ' + this.col + ', row ' + this.row + ', ' + section + ', ' + state
    }
  },
  methods: {
    toogle () {
      this.toogleRowCol({
        col: this.col - 1,
        row: this.row - 1,
        bar: this.bar
      })
    },
    ...mapMutations([
      'toogleRowCol'
    ])
  }
}
</script>

<style scoped>
.item {
  position: relative;
  display: block;
  width: 30px;
  height: 36px;
  padding: 0;
  margin: 6px auto;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.kernel {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  transition: transform 220ms ease-out;
}

.kernel-body {
  position: absolute;
  inset: 0;
  /* asymmetric teardrop / maize kernel shape */
  border-radius: 60% 60% 40% 40% / 70% 70% 30% 30%;
  background: var(--amate-warm, #f0e3c5);
  border: 1px solid var(--ink-trace, rgba(60, 40, 20, 0.25));
  box-shadow:
    inset 0 1px 2px rgba(255, 248, 230, 0.6),
    inset 0 -2px 3px rgba(120, 80, 40, 0.18),
    0 1px 2px rgba(40, 25, 10, 0.18);
  transition:
    background 220ms ease-out,
    box-shadow 220ms ease-out,
    border-color 220ms ease-out;
}

.kernel-sheen {
  position: absolute;
  top: 12%;
  left: 22%;
  width: 28%;
  height: 22%;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%,
                rgba(255, 250, 232, 0.85),
                rgba(255, 250, 232, 0) 70%);
  pointer-events: none;
  opacity: 0.7;
  transition: opacity 220ms ease-out;
}

.kernel-ring {
  position: absolute;
  left: 50%;
  bottom: -4px;
  transform: translateX(-50%);
  width: 70%;
  height: 6px;
  border-radius: 50%;
  background: radial-gradient(ellipse at center,
                var(--cinabrio, #9b2a25) 0%,
                rgba(155, 42, 37, 0) 70%);
  opacity: 0;
  transition: opacity 220ms ease-out;
  pointer-events: none;
}

/* Active = sacred grain of maize, illuminated */
.item.active .kernel {
  transform: scale(1);
  animation: kernel-pop 240ms ease-out;
}

.item.active .kernel-body {
  background: radial-gradient(ellipse at 45% 35%,
                var(--maíz, #d9a531) 0%,
                var(--maíz-deep, #a87212) 75%);
  border-color: var(--maíz-deep, #a87212);
  box-shadow:
    inset 0 1px 2px rgba(255, 240, 180, 0.7),
    inset 0 -3px 5px rgba(90, 50, 10, 0.45),
    0 2px 4px rgba(155, 42, 37, 0.35),
    0 0 8px rgba(217, 165, 49, 0.25);
}

.item.active .kernel-sheen {
  opacity: 0.9;
}

.item.active .kernel-ring {
  opacity: 0.45;
}

/* Hover */
.item:hover .kernel {
  transform: scale(1.05);
}

.item:hover .kernel-body {
  box-shadow:
    inset 0 1px 2px rgba(255, 248, 230, 0.6),
    inset 0 -2px 3px rgba(120, 80, 40, 0.22),
    0 3px 6px rgba(40, 25, 10, 0.28);
}

.item.active:hover .kernel-body {
  box-shadow:
    inset 0 1px 2px rgba(255, 240, 180, 0.75),
    inset 0 -3px 5px rgba(90, 50, 10, 0.5),
    0 4px 9px rgba(155, 42, 37, 0.45),
    0 0 14px rgba(217, 165, 49, 0.35);
}

/* Focus visible — sacred cinnabar outline */
.item:focus-visible {
  outline: 2px solid var(--cinabrio, #9b2a25);
  outline-offset: 2px;
  border-radius: 12px;
}

/* Pop animation on activation */
@keyframes kernel-pop {
  0%   { transform: scale(0.95); }
  60%  { transform: scale(1.03); }
  100% { transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .kernel,
  .kernel-body,
  .kernel-sheen,
  .kernel-ring {
    transition: none;
  }
  .item.active .kernel {
    animation: none;
  }
}
</style>



// WEBPACK FOOTER //
// Item.vue?1674d551